import { BulkActionResultTabs } from "components/BulkActions/types";

export const TABS_ORDER = [
  BulkActionResultTabs.Completed,
  BulkActionResultTabs.Failed,
  BulkActionResultTabs.Pending,
];
